export const secondaryButtonIconColour = 'primary-500'
export const copyButtonIconColour = 'primary-500'
